<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
          >商品管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>Ai辅助图</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form_container">
      <h1>Ai辅助图设置</h1>
      <div class="content_wrap">
        <div class="block">
          <div class="block_item" v-if="false">
            <p><span class="mark">*</span>AI辅助图01</p>
            <div class="radio_box">
              <el-radio-group v-model="formData.aipic1_site">
                <el-radio label="正面">正面</el-radio>
                <!-- <el-radio label="背面">背面</el-radio>
                <el-radio label="局部细节">局部细节</el-radio> -->
              </el-radio-group>
            </div>
          </div>
          <div class="block_item">
            <p><span class="mark">*</span>产品正面</p>
            <!-- <p class="red">JPG或者PNG格式，尺寸比例宽度500像素，高度不限制</p> -->
            <!-- @mouseleave="creenIndex = ''" -->
            <div class="upload_box" @mouseenter="enter(1)">
              <el-upload
                action
                list-type="picture-card"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :http-request="beforeAvatarUpload"
              >
                <div v-if="formData.aipic1">
                  <img :src="formData.aipic1" class="avatar" />
                  <div
                    class="el-upload-list__item-actions flex-rowc"
                    v-show="creenIndex == 1"
                  >
                    <span
                      @click.stop="handlePictureCardPreview(formData.aipic1, 1)"
                      ><i class="iconfont icon-fangda"></i
                    ></span>
                    <span @click.stop="handleRemove(1)"
                      ><i class="iconfont icon-icon_shanchu-"></i
                    ></span>
                  </div>
                </div>

                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
        </div>

        <div class="block">
          <div class="block_item" v-if="false">
            <p><span class="mark">*</span>AI辅助图02</p>
            <div class="radio_box">
              <el-radio-group v-model="formData.aipic2_site">
                <!-- <el-radio label="正面">正面</el-radio> -->
                <el-radio label="背面">背面</el-radio>
                <!-- <el-radio label="局部细节">局部细节</el-radio> -->
              </el-radio-group>
            </div>
          </div>
          <div class="block_item">
            <p><span class="mark">*</span>产品背面</p>
            <!-- <p class="red">JPG或者PNG格式，尺寸比例宽度500像素，高度不限制</p> -->
            <!-- @mouseleave="creenIndex = ''" -->
            <div class="upload_box" @mouseenter="enter(2)">
              <el-upload
                action
                list-type="picture-card"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :http-request="beforeAvatarUpload"
              >
                <div v-if="formData.aipic2">
                  <img :src="formData.aipic2" class="avatar" />
                  <div
                    class="el-upload-list__item-actions flex-rowc"
                    v-show="creenIndex == 2"
                  >
                    <span
                      @click.stop="handlePictureCardPreview(formData.aipic2, 2)"
                      ><i class="iconfont icon-fangda"></i
                    ></span>
                    <span @click.stop="handleRemove(2)"
                      ><i class="iconfont icon-icon_shanchu-"></i
                    ></span>
                  </div>
                </div>

                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
        </div>

        <div class="block">
          <div class="block_item" v-if="false">
            <p><span class="mark">*</span>AI辅助图03</p>
            <div class="radio_box">
              <el-radio-group v-model="formData.aipic3_site">
                <el-radio label="正面">正面</el-radio>
                <el-radio label="背面">背面</el-radio>
                <el-radio label="局部细节">局部细节</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="block_item">
            <p><span class="mark">*</span>产品局部细节</p>
            <!-- <p class="red">JPG或者PNG格式，尺寸比例宽度500像素，高度不限制</p> -->
            <!-- @mouseleave="creenIndex = ''" -->
            <div class="upload_box" @mouseenter="enter(3)">
              <el-upload
                action
                list-type="picture-card"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :http-request="beforeAvatarUpload"
              >
                <div v-if="formData.aipic3">
                  <img :src="formData.aipic3" class="avatar" />
                  <div
                    class="el-upload-list__item-actions flex-rowc"
                    v-show="creenIndex == 3"
                  >
                    <span
                      @click.stop="handlePictureCardPreview(formData.aipic3, 3)"
                      ><i class="iconfont icon-fangda"></i
                    ></span>
                    <span @click.stop="handleRemove(3)"
                      ><i class="iconfont icon-icon_shanchu-"></i
                    ></span>
                  </div>
                </div>

                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="handleSubmit">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import {
  getCommidityDetail,
  editCommidity,
  uploadImage,
  encryptstringview,
} from "../../../api/api";
export default {
  name: "cAiImages",
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,

      loading: false,

      id: "",
      formData: {
        Method: "ams_shop_commodity_edit",
        id: "",
        aipic1_site: "正面",
        aipic1: "",
        aipic2_site: "背面",
        aipic2: "",
        aipic3_site: "局部细节",
        aipic3: "",
      },
      creenIndex: "",
    };
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.id = id;
        this.getDetail();
      } else {
        this.$router.back();
      }
    },

    getDetail() {
      this.loading = true;
      getCommidityDetail({ id: this.id }).then((res) => {
        this.formData.id = res.id ? res.id : "";
        // this.formData.aipic1_site = res.aipic1_site ? res.aipic1_site : "";
        this.formData.aipic1 = res.aipic1 ? res.aipic1 : "";
        // this.formData.aipic2_site = res.aipic2_site ? res.aipic2_site : "";
        this.formData.aipic2 = res.aipic2 ? res.aipic2 : "";
        // this.formData.aipic3_site = res.aipic3_site ? res.aipic3_site : "";
        this.formData.aipic3 = res.aipic3 ? res.aipic3 : "";

        this.loading = false;
      });
    },
    // 移出图片
    handleRemove(isType) {
      if (isType == 1) {
        this.formData.aipic1 = "";
      } else if (isType == 2) {
        this.formData.aipic2 = "";
      } else if (isType == 3) {
        this.formData.aipic3 = "";
      }
    },
    // 大图预览
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    // 移入图片区域
    enter(type) {
      console.log(type, "====");
      this.creenIndex = type;
    },

    handleAvatarSuccess(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJPG) {
        this.$message.error("缩略图只能是图片");
      }
    },
    beforeAvatarUpload(e) {
      let { creenIndex } = this;
      var formData = new FormData();
      formData.append("imgfile", e.file);
      this.loading = true;
      uploadImage(formData).then((res) => {
        console.log(res, creenIndex, "====");
        if (res.result) {
          this.loading = false;
          if (creenIndex == 1) {
            this.formData.aipic1 = res.url;
          } else if (creenIndex == 2) {
            this.formData.aipic2 = res.url;
          } else if (creenIndex == 3) {
            this.formData.aipic3 = res.url;
          } 
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    handleSubmit() {
      let { formData } = this;
      let params = JSON.parse(JSON.stringify(formData));
      if (params.aipic1_site == "") {
        this.$message.warning("请选择AI辅助图01-类别");
        return;
      }
      if (params.aipic1 == "") {
        this.$message.warning("请上传AI辅助图01");
        return;
      }
      if (params.aipic2_site == "") {
        this.$message.warning("请选择AI辅助图02-类别");
        return;
      }
      if (params.aipic2 == "") {
        this.$message.warning("请上传AI辅助图02");
        return;
      }
      if (params.aipic3_site == "") {
        this.$message.warning("请选择AI辅助图03-类别");
        return;
      }
      if (params.aipic3 == "") {
        this.$message.warning("请上传AI辅助图03");
        return;
      }
      this.loading = true;
      editCommidity(params).then((res) => {
        let data = res;
        if (data.result) {
          this.loading = false;
          this.$message.success(data.message);
          // setTimeout(() => {
          //   this.loading = false;
          //   this.$router.back();
          // }, 500);
        } else {
          this.loading = false;
          this.$message.error(data.message || "服务器报错，请稍后～");
        }
      });
    },
    // 图片路径的分割
    imgSplit(url) {
      if (url != "") {
        if (url.indexOf("upload")) {
          let splitArr = url.split("/upload/");
          return splitArr[splitArr.length - 1];
        } else if (url.indexOf("Upload")) {
          let splitArr = url.split("/Upload/");
          return splitArr[splitArr.length - 1];
        }
      } else {
        return "";
      }
    },

    handleReturn() {
      // history.back();
      this.$router.push({ name: "cManageIndex" });
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      align-items: flex-start;
      flex-wrap: wrap;
      .block {
        margin-right: 80px;
        .block_item {
            margin-bottom: 20px;
            &:last-child {
                margin-bottom: 0;
            }
        }
      }
    }
  }
}
</style>